const trueValues = new Set(["true", "1", "si", "sí", "yes", "activo"]);

export function hasPermission(userData, ...keys) {
  if (!userData) return false;
  return keys.some((key) => trueValues.has(String(userData?.[key] ?? "").toLowerCase()));
}

export function canAccess(userData, feature) {
  const rules = {
    cuentas: ["permiso_cuentas", "cuentas"],
    usuarios: ["permiso_usuarios", "usuarios"],
    operaciones: ["permiso_operaciones", "sesiones"],
    cierres: ["permiso_cierres", "cierres"],
    appClientes: ["permiso_appclientes", "cierres"],
    inventario: ["permiso_inventario", "cierres", "sesiones", "opciones"],
    alquileres: ["permiso_alquileres", "cierres", "sesiones"],
    ordenPago: ["permiso_ordendepago", "cierres"],
    pagos: ["permiso_pagos", "cierres"],
    opciones: ["permiso_opciones", "opciones"],
  };

  return hasPermission(userData, ...(rules[feature] || []));
}

export function canEdit(userData) {
  return hasPermission(userData, "permiso_editar", "cierres");
}

export function canLoad(userData) {
  return hasPermission(userData, "permiso_cargar", "cierres", "sesiones");
}

export function canDownloadExcel(userData) {
  return hasPermission(userData, "permiso_descargarexcel", "cierres");
}

export function canViewPrices(userData) {
  const tipoUsuario = String(userData?.IdTipoUsuario ?? "");
  return ["0", "2"].includes(tipoUsuario) || hasPermission(userData, "permiso_verprecios");
}
